import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './definitions-config';

import { getAllUserDetails } from '../../../services/apiService';

import { toast } from 'react-toastify';

const pageSize = 10;

const userType = 'free';

function FreeUsersTable({ isApplyDefaultFilter, setIsApplyDefaultFilter }) {
  const [gridApi, setGridApi] = useState(null);

  const getServerSideDatasource = () => {
    return {
      getRows: (params) => {
        const getDateFilterObj = (dateFilter) => {
          if (!dateFilter) return null;
          const date = dateFilter.dateFrom.split(' ')[0];
          let sign = '';
          if (dateFilter.type === 'equals') sign = '$eq';
          else if (dateFilter.type === 'greaterThan') sign = '$gt';

          return {
            [sign]: date,
          };
        };

        const body = {
          filter: {
            firstName: params.request?.filterModel?.name?.filter || null,
            email: params.request?.filterModel?.email?.filter || null,
            cohort: params.request?.filterModel?.cohort?.filter || null,
            planType: params.request?.filterModel?.planType?.values || null,
            courseType: params.request?.filterModel?.courseType?.values || null,

            signupDate: getDateFilterObj(
              params.request?.filterModel?.signupDate
            ),
            enrollmentDate: getDateFilterObj(
              params.request?.filterModel?.enrollmentDate
            ),

            userType,
          },

          pagination: {
            start: params.request.startRow,
            end: params.request.endRow,
          },
        };

        try {
          getAllUserDetails(body).then((response) => {
            params.successCallback(
              response?.data || [],
              response?.pagination?.totalCount || 0
            );
          });
        } catch (error) {
          console.error(error);
          params.failCallback();
          toast.error('Failed to fetch data');
        }
      },
    };
  };

  const onGridReady = React.useCallback(
    (params, mIsApplyDefaultFilter = true) => {
      setGridApi(params);

      if (mIsApplyDefaultFilter) {
        params.api.setFilterModel({});
        setIsApplyDefaultFilter(false);
      }

      const datasource = getServerSideDatasource();
      params.api.setServerSideDatasource(datasource);
    },
    []
  );

  const reloadData = () => {
    if (gridApi) {
      onGridReady(gridApi, isApplyDefaultFilter);
    }
  };

  useEffect(() => {
    reloadData();
  }, []);

  useEffect(() => {
    if (isApplyDefaultFilter) reloadData();
  }, [isApplyDefaultFilter]);

  return (
    <div>
      <div
        style={{
          backgroundColor: 'var(--card-background, #fff)',
          borderRadius: 16,
          border: '1px solid var(--border-light, rgba(0,0,0,0.07))',
          boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))',
          overflow: 'hidden',
        }}
      >
        <div className='ag-theme-alpine' style={{ width: '100%' }}>
          <AgGridReact
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            tooltipShowDelay={0}
            tooltipHideDelay={2000}
            onGridReady={onGridReady}
            rowHeight={60}
            domLayout='autoHeight'
            rowModelType='serverSide'
            serverSideStoreType='partial'
            animateRows={true}
            serverSideInfiniteScroll={true}
            pagination={true}
            suppressPaginationPanel={false}
            paginationPageSize={pageSize}
            cacheBlockSize={pageSize}
          />
        </div>
      </div>
    </div>
  );
}

export default FreeUsersTable;
